function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("title", null, "chevrons-right");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Invision",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "chevrons-right",
  transform: "translate(0.625390, 0.748430)",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.66367197,1.05078815 L14.7378904,8.75000774 L7.66367197,16.450789 C7.55257845,16.5710235 7.49765635,16.7230153 7.49765635,16.8750071 C7.49765635,17.0434451 7.56480455,17.2112965 7.69906282,17.3339915 C7.95296907,17.5683665 8.34710956,17.5525069 8.58148456,17.2992027 L16.081484,9.17420267 C16.303671,8.93373369 16.303671,8.56639026 16.081484,8.32576512 L8.58148396,0.200765121 C8.34710896,-0.0525164727 7.95296848,-0.0684142236 7.69906223,0.165976274 C7.44492233,0.400788772 7.42929697,0.796881902 7.66367197,1.05078815 Z M8.58554721,9.17735099 C8.80773485,8.93688201 8.80773485,8.56953858 8.58554721,8.32891344 L1.08554721,0.203913438 C0.851172209,-0.0493681554 0.457031727,-0.0652659062 0.203125477,0.169124591 C-0.0519919395,0.402288425 -0.066640377,0.798420894 0.167726874,1.05232714 L7.24194586,8.75154673 L0.166015625,16.450789 C0.0549221039,16.5710235 0,16.7230153 0,16.8750071 C0,17.0434451 0.0671482086,17.2112965 0.201405883,17.3339915 C0.455312133,17.5683665 0.849452615,17.5525069 1.08382761,17.2992027 L8.58554661,9.17735099 L8.58554721,9.17735099 Z",
  id: "Shape"
})));
const SvgIconChevrons = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "19px",
    viewBox: "0 0 17 19",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconChevrons, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-chevrons.867919a1.svg";
export { ForwardRef as ReactComponent };